<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <!-- 左侧菜单 -->
      <navMenu :active="active" @getMenuClick="getMenuClick"></navMenu>
      <!-- 右侧内容区域 -->
      <div class="content" v-loading.lock="loading">
        <div class="template-main content_box">
          <div class="content_html" v-html="content"></div>
          <div class="plan-wrap">
            <div class="plan-title">
              此系统将协助您完成参展前的一系列准备工作，请务必在各项截止日期前完成！
            </div>
            <!-- 进度与截止日期标题部分 -->
            <div class="plan-top">
              <div class="title">进度与截止日期（{{ stepStatus }}）</div>
            </div>
            <!-- 步骤条部分 -->
            <div class="plan-step">
              <div
                class="plan-item"
                v-for="(item, index) in stepMenuList"
                :key="index"
                :class="{
                  marLeft: index,
                  wait: item.state == '',
                  skip: item.state == 'wait' && item.skip,
                  cursor: item.state == 'wait' && item.skip == false,
                  process: item.state == 'process',
                  finish: item.state == 'finish',
                  error: item.state == 'error',
                }"
                @click="change(index, item.action, item.link_type)"
              >
                <p class="title" :class="{
                  titlenoborder: !item.deadline
                }">{{ item.name }}</p>
                <p>{{ item.deadline }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="conf-btn flex">
          <!-- 可跳过需要验证 -->
          <template v-if="detail.is_skip == 1 && detail.is_verify == 1">
            <div class="btn" @click="next('skip')">跳过</div>
            <div class="btn next-btn" @click="next('next')">下一步</div>
          </template>
          <!-- 可跳过无需验证 -->
          <template v-if="detail.is_skip == 1 && detail.is_verify == 0">
            <!-- 24.9.1 首页已知悉改成完成 dxm-->
            <div class="btn next-btn" @click="next('known')">开始</div>
          </template>
          <!-- 不可跳过需要验证 -->
          <template v-if="detail.is_skip == 0 && detail.is_verify == 1">
            <div class="btn next-btn" @click="next('next')">下一步</div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { skipOrReadStep, companyMenuDetail, myMenuStep } from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
export default {
  components: { top, navMenu },
  name: "home",
  data() {
    return {
      id: "",
      loading: false,
      active: 0,
      stepMenuList: [],
      detail: {},
      content: "",
      stepStatus: "",
    };
  },
  mounted() {
    this.getData();
  },
  created() {},
  methods: {
    //获取navmenu组件传递过来的菜单列表数据
    getMenuClick(val) {
      this.stepMenuList = val;
      this.$forceUpdate();
    },
    // 初始化数据
    getData() {
      let stepMenuList = JSON.parse(localStorage.getItem("menu"));
      this.stepMenuList = stepMenuList;
      var index = stepMenuList.findIndex(function (item) {
        return item.link_url == "index";
      });
      this.detail = stepMenuList[index];
      this.active = index;
      this.id = stepMenuList[index].id;
      // 获取页面标题 副标题 富文本
      this.getContent(this.id);
      this.getStepStatus();
    },
    //  获取内容
    getContent(id) {
      this.loading = true;
      companyMenuDetail({ id })
        .then((res) => {
          //console.log(res, "<======res");
          this.loading = false;
          if (res.data.code == 1) {
            let { data } = res.data;
            if (data.content) {
              data.content = data.content.replace(
                /<img/g,
                "<img style='max-width:100%;height:auto;'"
              );
              data.content = data.content.replace(
                /<p/g,
                "<p style='max-width:100%;'"
              );
            }
            this.content = data.content;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getStepStatus() {
      myMenuStep()
        .then((res) => {
          if (res.data.code == 1) {
            let { data } = res.data;
            this.stepStatus = data.schedule;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 步骤条点击事件
    change(index, action, link_type) {
      if (action == 0) {
        return false;
      }
      let { link_url, id } = this.stepMenuList[index];
      if (link_type == 2) {
        window.open(link_url, "_blank");
      } else if (link_url == "conference") {
        this.$router.push({
          path: link_url,
          query: {
            id,
          },
        });
      } else {
        this.$router.push({
          path: link_url,
        });
      }
    },
    // 跳转下一步
    next(type) {
      if (type == "next") {
        //下一步
        // if (this.detail.action == 1 || this.detail.action == 4) {
        //   this.toPath();
        // } else {
        //   this.$message.warning("请完善信息!");
        // }
        if (this.detail.action >= 2) {
          this.toPath();
        } else if (this.detail.is_verify == 1) {
          this.$message.warning("请完善信息!");
        } else {
          this.toPath();
        }
      } else if (type == "skip") {
        //跳过
        this.skipOrReadStep(1);
      } else if (type == "known") {
        //已知悉
        this.skipOrReadStep(2);
      }
    },
    // 跳过或者已知悉
    skipOrReadStep(action) {
      let data = {
        action,
        mark: this.detail.mark,
      };
      skipOrReadStep(data)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success("操作成功");
            this.toPath();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toPath() {
      this.active = this.active + 1;
      let { link_url, id } = this.stepMenuList[this.active];
      if (link_url == "conference") {
        this.$router.push({
          path: link_url,
          query: {
            id,
          },
        });
      } else {
        this.$router.push({
          path: link_url,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content_box {
  padding: 30px;
  box-sizing: border-box;
  border-radius: 10px;
  background: #fff;
  margin-top: 0;
  min-height: calc(100vh - 250px);
  .content_html {
    width: 100%;
    line-height: 30px;
  }
  .plan-wrap {
    margin-top: 37px;
    .plan-title {
      font-size: 18px;
      font-weight: 500;
      color: #ff862a;
      line-height: 30px;
      margin-bottom: 20px;
    }
    // 标题部分
    .plan-top {
      display: flex;
      align-items: center;
      color: #2c2c2e;
      .title {
        font-size: 20px;
        font-weight: 600;
        margin-right: 120px;
      }
      .plan-status {
        height: 28px;
        width: 369px;
        padding: 0 15px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        border-radius: 16px;
        border: 1px solid #b8b8b8;
        .plan-item {
          font-size: 15px;
          span {
            width: 9px;
            height: 9px;
            margin-right: 10px;
            display: inline-block;
            background: #c7c7cc;
          }
          .finish-icon {
            background: #44d7b6;
          }
          .verify-icon {
            background: #ff770a;
          }
          .skip-icon {
            background: #ffd60a;
          }
          .know-icon {
            background: #0091ff;
          }
        }
      }
    }
    // 步骤部分
    .plan-step {
      display: flex;
      margin: 20px auto 42px;
      .plan-item {
        // width: 172px;
        flex: 1;
        // height: 80px;
        height: 65px;
        color: #fff;
        cursor: inherit;
        font-size: 12px;
        padding: 14px 19px 0 0;
        text-align: center;
        box-sizing: border-box;
        background: url("../assets/icon_gray.jpg") no-repeat;
        background-size: 100% 100%;
        cursor: not-allowed;
        line-height: 13px;
        .title {
          width: 85px;
          
          font-size: 13px;
          font-weight: 500;
          margin: 0 auto;
          padding-bottom: 5px;
          margin-bottom: 5px;
          border-bottom: 1px solid #fff;
        }
        .titlenoborder{
          border-bottom: 0 none;
          line-height: 35px;
        }
        &:last-child {
          padding-right: 10px;
          padding-left: 9px;
        }
      }
      .plan-item:hover {
        transform: scale(1.1);
        position: relative;
        z-index: 999;
        padding-right: 10px;
        padding-left: 9px;
      }
      .marLeft {
        margin-left: -36px;
        position: relative;
        z-index: 9;
      }
      // 审核中
      .process {
        cursor: pointer;
        background: url("../assets/icon_verify.jpg") no-repeat;
        background-size: 100% 100%;
      }
      // 已完成
      .finish {
        cursor: pointer;
        background: url("../assets/icon_finish.jpg") no-repeat;
        background-size: 100% 100%;
      }
      // 未通过
      .error {
        cursor: pointer;
        background: url("../assets/icon_fail.jpg") no-repeat;
        background-size: 100% 100%;
      }
      // 已跳过
      .skip {
        cursor: pointer;
        background: url("../assets/icon_skip.jpg") no-repeat;
        background-size: 100% 100%;
      }
      .cursor {
        cursor: pointer;
      }
    }
    // 最新消息
    .message {
      width: 750px;
      height: 54px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 20px;
      color: #2c2c2e;
      padding: 0 27px;
      box-sizing: border-box;
      background: #ebf0fc;
      border-radius: 29px;
      .email-icon {
        width: 28px;
        height: 21px;
        .el-image {
          display: block;
        }
      }
      .message-content {
        flex: 1;
        font-size: 20px;
        color: #2c2c2e;
        margin-left: 16px;
        .message-text {
          width: 600px;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          white-space: nowrap;
        }
      }
    }
  }
}
.conf-btn {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  .btn {
    min-width: 148px;
    height: 40px;
    cursor: pointer;
    font-size: 19px;
    margin: 0 10px;
    font-weight: 500;
    color: #2690e6;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #008dff;
    &:hover {
      text-decoration: underline;
    }
  }
  .next-btn {
    color: #fff;
    background: #008dff;
  }
}
@media only screen and (max-width: 767px) {
  .template-main {
    margin-top: 10px;
  }
  .content {
    margin: 0;
    padding: 20px 20px 150px 20px;
    .content_html {
      width: 100%;
    }
  }
}
</style>